<template>
  <div class="order-details-payment-plan">
   <MySteps 
      :steps="stepList" 
      :current="currentStep" 
      activeColor="#ff4d4f"
      inactiveColor="#909399"
      finishColor="#409eff"
      direction="vertical"
    />
  </div>
</template>

<script>
import MySteps from '@/components/MySteps/MySteps.vue';
export default {
  name: "orderDetailsPaymentPlan",
  components: {
    MySteps,
  },
  props: {
    stepList: {
      type: Array,
      default: () => [],
    },
    currentStep: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
     
    };
  },
  async mounted() {},
  methods: {},
  computed: {
    orderDetails() {
      return this.$store.getters.orderDetails;
    },
  },
};
</script>

<style scoped lang="scss">
.order-details-payment-plan {
  padding: 20px 10px;
  background: #fff;
  border-radius: 8px;
  margin-top: 16px;
 .step-item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 26px;
    font-size: 15px;
  }
  .left{
    display: flex;
    flex-direction: column;
    .span{
      font-size: 12px;
      color: #777777;
      margin-top: 4px;
    }
  }
  .right{
    padding: 6px 16px;
    border-radius: 16px;
    background: #E9E9E9;
    color: #777777;
  }
}
</style>
